/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import Container from "@material-ui/core/Container";

import { MadeWithLove } from "components/MadeWithLove/MadeWithLove.jsx";
import { setAccessToken } from "containers/authenticated.js";
import { createGuest, verifyLogin } from "services/authProvider.js";

import signinStyle from "assets/jss/material-dashboard-react/layouts/signinStyle.jsx";

import { staticData } from "config.js";

function resolveNextPathFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const rawNext = (params.get("next") || "").trim();
  if (rawNext && rawNext.startsWith("/") && !rawNext.startsWith("//")) {
    return rawNext;
  }
  return "/dashboard";
}

class StartPage extends Component {
  static getDerivedStateFromProps(props, state) {
    const searchPath = (props.location && props.location.search) || "";
    const params = new URLSearchParams(searchPath);
    const token = (params.get("token") || "").trim();
    if (token) {
      const nextPath = resolveNextPathFromSearch(searchPath);
      setAccessToken({ token: token });
      verifyLogin().then(() => {
        props.history.push(nextPath);
      });
    }
    return state;
  }

  getNextPath = () => {
    const searchPath = (this.props.location && this.props.location.search) || "";
    return resolveNextPathFromSearch(searchPath);
  };

  getAuthLink = pathname => {
    const nextPath = this.getNextPath();
    const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
    if (!nextPath || nextPath === "/dashboard") {
      return normalizedPath;
    }

    return `${normalizedPath}?next=${encodeURIComponent(nextPath)}`;
  };

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null
    };
  }
  // eslint-disable-next-line no-unused-vars
  submitForm = e => {
    e.preventDefault();
    createGuest()
      .then(data => {
        this.props.history.push("/mydevices");
      })
      .catch(error => {
        this.setState({ errorMessage: "Something went wrong" });
      });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <img
            alt="logo"
            className={classes.logo}
            src={staticData.company.logoURL}
          />
          <Typography component="h3" variant="h5">
            IoT Dashboard
          </Typography>
          <Typography component="h5" variant="h7">
            Visualize Data from your Devices
          </Typography>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={this.submitForm}
          >
            Start Now
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href={this.getAuthLink("signin")} variant="body2">
                {"Already have an account? Sign In"}
              </Link>
            </Grid>
            <Grid item>
              <Link href={this.getAuthLink("signup")} variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </div>
        <Box mt={5}>
          <MadeWithLove />
        </Box>
      </Container>
    );
  }
}

export default withStyles(signinStyle)(StartPage);
